import { useEffect } from 'react'
import { View, Text, Pressable, StyleSheet } from 'react-native'
import { AlertTriangle } from 'lucide-react-native'
import { colors, spacing, borderRadius } from '../theme'
import { sentryCaptureException } from '../lib/sentry'

export function ScreenErrorBoundary({ error, retry }: { error: Error; retry: () => void }) {
  useEffect(() => {
    sentryCaptureException(error, { source: 'screen_error_boundary' })
  }, [error])

  return (
    <View style={styles.container}>
      <AlertTriangle size={48} color={colors.warning} />
      <Text style={styles.title}>Noget gik galt</Text>
      <Text style={styles.message}>{error.message}</Text>
      <Pressable onPress={retry} style={styles.button}>
        <Text style={styles.buttonText}>Prøv igen</Text>
      </Pressable>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing.xl,
    backgroundColor: colors.background,
    gap: spacing.md,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.text.primary,
  },
  message: {
    fontSize: 14,
    color: colors.text.secondary,
    textAlign: 'center',
  },
  button: {
    marginTop: spacing.md,
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.sm,
    backgroundColor: colors.primary,
    borderRadius: borderRadius.md,
  },
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
})
